import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { ContentsState, ContentsItem, ContentDetailsApiResponse } from '../types';

const initialState: ContentsState = {
  contentDetails: undefined!,
  contentsList: [],
};

const contentsSlice = createSlice({
  name: 'contents',
  initialState,
  reducers: {
    setContentDetailsAction(state, action: PayloadAction<ContentDetailsApiResponse>) {
      state.contentDetails = action.payload;
    },

    clearContentDetailsAction(state) {
      state.contentDetails = undefined!;
    },

    setContentsListAction(state, action: PayloadAction<ContentsItem[]>) {
      state.contentsList = action.payload;
    },

    clearContentsListAction(state) {
      state.contentsList = [];
    },
  },
});

export const { setContentDetailsAction, clearContentDetailsAction, setContentsListAction, clearContentsListAction } = contentsSlice.actions;

export const getContentDetails = (state: RootState): ContentsState => state.contents;

export default contentsSlice.reducer;
